var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_9169",
    "data-name": "\\uC0AC\\uAC01\\uD615 9169",
    width: 29,
    height: 29,
    fill: "#ff5f00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8281",
    "data-name": "\\uADF8\\uB8F9 8281",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36936",
    "data-name": "\\uD328\\uC2A4 36936",
    d: "M36.154,25.858H34.435a.446.446,0,0,1,0-.893h1.719a.216.216,0,0,0,.216-.216V19.618a.214.214,0,0,0-.024-.1l-2.19-4.261a.216.216,0,0,0-.192-.117H27.143V25.412a.446.446,0,0,1-.893,0V14.7a.446.446,0,0,1,.446-.446h7.267a1.105,1.105,0,0,1,.986.6l2.19,4.26a1.11,1.11,0,0,1,.123.507v5.131A1.11,1.11,0,0,1,36.154,25.858Z",
    transform: "translate(-10.623 -5.767)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36937",
    "data-name": "\\uD328\\uC2A4 36937",
    d: "M36.617,21.715H30.7a.446.446,0,0,1-.446-.446V17.7a.446.446,0,0,1,.446-.446h4.147a.446.446,0,0,1,.4.248l1.773,3.572a.446.446,0,0,1-.4.645Zm-5.474-.893H35.9l-1.33-2.679H31.143Z",
    transform: "translate(-12.242 -6.981)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36938",
    "data-name": "\\uD328\\uC2A4 36938",
    d: "M24.626,33.143H15.7a.446.446,0,1,1,0-.893h8.93a.446.446,0,1,1,0,.893Z",
    transform: "translate(-6.172 -13.052)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36939",
    "data-name": "\\uD328\\uC2A4 36939",
    d: "M6.078,24.24H3.7a.446.446,0,0,1-.446-.446V11.656A1.407,1.407,0,0,1,4.656,10.25H16.429a1.407,1.407,0,0,1,1.406,1.406V14.07a.446.446,0,1,1-.893,0V11.656a.513.513,0,0,0-.513-.513H4.656a.513.513,0,0,0-.513.513V23.347H6.078a.446.446,0,1,1,0,.893Z",
    transform: "translate(-1.315 -4.148)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_421",
    "data-name": "\\uC120 421",
    d: "M5.649.143H-.3A.446.446,0,0,1-.75-.3.446.446,0,0,1-.3-.75H5.649A.446.446,0,0,1,6.1-.3.446.446,0,0,1,5.649.143Z",
    transform: "translate(10.424 17.567)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_422",
    "data-name": "\\uC120 422",
    d: "M.887.143H-.3A.446.446,0,0,1-.75-.3.446.446,0,0,1-.3-.75H.887A.446.446,0,0,1,1.334-.3.446.446,0,0,1,.887.143Z",
    transform: "translate(2.685 17.567)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_475",
    "data-name": "\\uD0C0\\uC6D0 475",
    d: "M2.078-.75A2.828,2.828,0,1,1-.75,2.078,2.831,2.831,0,0,1,2.078-.75Zm0,4.762A1.935,1.935,0,1,0,.143,2.078,1.937,1.937,0,0,0,2.078,4.012Z",
    transform: "translate(5.066 17.567)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_476",
    "data-name": "\\uD0C0\\uC6D0 476",
    d: "M2.078-.75A2.828,2.828,0,1,1-.75,2.078,2.831,2.831,0,0,1,2.078-.75Zm0,4.762A1.935,1.935,0,1,0,.143,2.078,1.937,1.937,0,0,0,2.078,4.012Z",
    transform: "translate(19.353 17.567)",
    fill: "#ff5f00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.a07d144fdcff5bdfc7fa633e7751cc80.svg";
export { ForwardRef as ReactComponent };